/* eslint-disable no-underscore-dangle */
/* eslint-disable no-shadow */
import { OrderMessageType } from '@easy-lib/modules/shared/models/ls.model';
import { OfflineSendStrategy } from '@easy-lib/modules/offline-ipo/models/offline-ipo.model';
import { FormControl } from '@angular/forms';

export interface newOMSIOrder {
	order: IOrder;
}

export class IOrder {
	minimumQuantity?: number;
	symbolIsin?: string;
	side?: Side;
	quantity?: number;
	price?: number;
	easyState?: EasyState;
	createDateTime?: string;
	id?: string;
	hon?: number;
	omsErrorDescription?: string;
	responseErrorMessage?: string;
	iceberg?: number;
	orderState?: number;
	validityType?: EasyValidityTypeCode;
	validityDate?: string;
	parentId?: string;
	orderFrom?: From;
	orderPlace?: number;
	isParentOfOnModifyBoard?: boolean;
	symbolName?: string;
	easySource?: EasySource;
	volumeAhead?: number;
	cautionAgreementSelected?: boolean;
	trades?: IOrderTrade[];
	isDraft?: boolean;

	// Offline Order
	state?: number;
	errorType?: number;
	sendStrategy?: OfflineSendStrategy;
	isOffline?: boolean;
}

export interface OrderPlaceResponseDto {
	orderPlaces: OrderPlaceChange[];
}
export interface OrderPlaceChange {
	orderId?: string;
	orderPlace?: number;
	volumeAhead?: number;
}

export const enum OrderPlaceState {
	Start = 1,
	Stop
}
export enum Side {
	Buy = 0,
	Sell = 1,
	Cross = 2,
	None = 3
}

export enum CalculatorMode {
	SellValue = 'SellValue',
	MinimumSell = 'MinimumSell',
	BuyPower = 'BuyPower',
	MinimumBuy = 'MinimumBuy'
}

export enum From {
	None = 0,
	Supervisor = 1,
	EasyTrader = 22,
	OrbisMobile = 33,
	OrbisDesktop = 34,
	OrbisAdmin = 35,
	System = 100,
	OfflineOrbis = 101,
	OrbisAlgo = 102,
	AlgoGroup = 103,
	AlgoMarketMaker = 104,
	OrbisOptionMobile = 110,
	OrbisOptionDesktop = 111,
	MarketMaker = 200
}
export enum EasyState {
	BeingCreated,
	InSendQueue,
	InDeleteQueue,
	InModifyQueue,
	WaitForOMSResponse,
	EditMode,
	GridEditMode,
	WaitForDelete,
	Done
}

export enum EasySource {
	Mobile = 0,
	Desktop = 1
}

export enum ConfirmableActionType {
	DELETE = 0,
	SEND = 1
}

export enum OmsOrderStates {
	None = 0, // [Description("نامشخص")]

	Modify = 1, // [Description("ویرایش")]
	PartiallyExecutedAndModified = 15, // [Description("بخشی انجام و مابقی ویرایش شده")]
	OnModifying = 16, // [Description("در حال ویرایش")]
	OnModifyBoard = 19, // [Description("ثبت در سیستم معاملات(ویرایش شده)")]
	OnModified = 67, // [Description("در حال ویرایش")] // parent

	Cancel = 3, // [Description("انصراف")]
	OnCanceling = 9, // [Description("در حال انصراف")]
	OnCancelError = 10, // [Description("خطا در انصراف")]
	CancelBySurveillance = 4, // [Description("حذف توسط ناظر")]
	DeleteBySupervisor = 40, // [Description("حذف توسط ناظر")]
	DeleteByNsc = 17, // [Description("حذف توسط سیستم معاملات")]
	CancelByBroker = 18, // [Description("نامشخص")] // WILL NOT OCCUR

	OnBoard = 6, // [Description("ثبت در سیستم معاملات")]
	OnSending = 7, // [Description("در حال ارسال")]

	PartiallyExecution = 8, // [Description("بخشی انجام شده")]

	Error = 2, // [Description("خطا")]
	OnModifyError = 11, // [Description("خطا در ویرایش")]

	Expired = 13, // [Description("منقضی شده")]

	PartiallyExecutedAndExpired = 14, // [Description("بخشی انجام و مابقی منقضی شده")]
	PartiallyExecutedAndError = 35, //  [Description("بخشی انجام و مابقی خطا اتفاق افتاده")]
	PartiallyExecutedAndCanceled = 36, // [Description("بخشی انجام و مابقی لغو شده است")]

	OrderExecuted = 20, // [Description("انجام شده")]

	Reject = 25, // [Description("غیرقابل قبول")] // WILL NOT OCCUR

	InOmsQueue = 28, // [Description("در صف سیستم")]

	Open = 29,

	SentToNsc = 30 // [Description("ثبت، در انتظار پایان پذیره‌نویسی")]

	// Not Used In OMS
	// Done = 5, // [Description("انجام شده")]
	// DeleteByBroker = 12, // [Description("حذف توسط کارگزار")] // WILL NOT OCCUR
	// PendingConfirm = 21, // [Description("نامشخص")] // WILL NOT OCCUR
	// Confirmed = 22, // [Description("نامشخص")] // WILL NOT OCCUR
	// PendingCancelOrder = 23, // [Description("نامشخص")] // WILL NOT OCCUR
	// CancelOrderConfirmed = 24, // [Description("نامشخص")] // WILL NOT OCCUR
	// CancelPendingOrderByUser = 26, // [Description("نامشخص")] // WILL NOT OCCUR
	// CancelCancelPendingOrderByUser = 27 // [Description("نامشخص")] // WILL NOT OCCUR
}

export interface IOrderChange {
	omsOrderId: string;
	orderState?: string;
	error?: number;
	remained?: number;
	hostOrderId?: number;
	orderFromCode?: number;
	messageType?: OrderMessageType;
}

export interface IOrderEvent {
	orderId: string;
	customerIsin: string;
	rawMessage: string;
	timestamp: Date;
	evt: Event;
}
export interface IOrderError {
	isr: string;
	functionCode: string;
	errorCode: number;
	errorText: string;
}

export enum Event {
	OmsError = 'OmsError',
	OrderModify = 'OrderModify',
	OrderSentToNSC = 'OrderSentToNSC'
}

export interface IOrderResult {
	isr: string;
	customerIsin: string;
	hon: string;
	side: Side;
	seqNumber: number;
	orderStatus: string;
	price: number;
	date: string;
	quantity: number;
	minimumQuantity: number;
	disclosedQuantity: number;
	validity: LSValidityType;
	validityDate: Date;
	functionCode: OrderResultFunctionCode;
	symbolIsin?: string;
	state?: string;
	freetext?: string;
}
export interface ILsOrderTrade {
	isr: string;
	tradeNumber: number;
	quantity: number;
	date: string;
	price: number;
	isin: string;
	side: Side;
	hasRemain: boolean;
	hon: string;
	remain: number;
	state: string;
	type: OrderMessageType;
}

export interface ISupervisorTrade {
	isr: string;
	tradeNumber: number;
	quantity: number;
	date: string;
	price: number;
	isin: string;
	side: string;
	customerIsin: string;
}
export interface IOrderTrade {
	dateTime: string;
	hidePrice?: number;
	isCancel?: boolean;
	orderId: string;
	price: number;
	quantity: number;
	side: number;
	symbolIsin: string;
	tradeNumber: number;
	hasRemain?: boolean;
	remain?: number;
}

export interface IOrderTradeCancel {
	isr: string;
	hon: string;
	tradeNumber: number;
}

export interface IOrderElimination {
	orderId: string;
}

export interface IOrderElimination {
	isr: string;
}

export enum LSValidityType {
	DAY = 'DAY',
	GOOD_TILL_DATE = 'GOOD_TILL_DATE',
	GOOD_TILL_CANCEL = 'GOOD_TILL_CANCEL',
	FILL_KILL = 'FILL_KILL',
	TRADING_SESSION = 'TRADING_SESSION'
}

export enum OrderResultFunctionCode {
	Add = '0001',
	Update = '0002',
	Delete = '0003'
}

export interface IOrderFromUrl {
	isin?: string;
	side?: string;
	quantity?: number;
	price?: number;
	editOrMake?: string;
	draftOrRegular?: string;
	id?: string;
	validityType?: number;
	// validityDateJalali?: string;
	validityDate?: string;
	iceberg?: string;
	financialProviderCode?: number;
	isMobile?: boolean;
	isEditMode?: boolean;
	quantityEntryType?: EntryType;
}

export const enum MarketDepthStateType {
	OrderFrom = 1,
	OrderFromDesktop,
	EditOrder,
	SparkLine,
	ContextMenu,
	Layouts,
	Popup,
	SearchPanel,
	CloneOrder
}

export interface IOrderFromMarketDepth {
	isin: string;
	side: string;
	quantity: number;
	price: number;
	type?: MarketDepthStateType;
	justOverWrite?: boolean;
}

export interface IEditOrderFromMarketDepth {
	quantity: number;
	price: number;
}

export interface IOrderFromSparkLine {
	isin: string;
	side: string;
	quantity?: number;
}

export interface IOrderFromContextMenu {
	isin: string;
	side: string;
	quantity?: number;
	price?: number;
}

export interface IOrderFromLayouts {
	side: string;
}

export interface IOrderFromPopup {
	isin: string;
	side: string;
}

export interface IOrderFromSearchPanel {
	isin: string;
	side: string;
}

export interface IBatchCreateRequestModel {
	draftIds: string[];
	removeDraftAfterCreate: boolean;
	orderFrom: From;
}

export interface BaseOrderResponse {
	id?: string | number | string[];
	message?: string;
	isSuccessful: boolean;
}

export interface IDeleteResponseModel {
	isSuccessful: boolean;
	message?: string;
	id?: string;
}
export interface IBatchDeleteRequestModel {
	orderIds: string[];
	draftIds: string[];
	orderFrom: From;
}

export interface IBatchDeleteResponseModel {
	draftIds: string[];
}

export enum OmsValidityType {
	Day = 0, // روز
	ValidToDate = 1, // معتبر تا تاریخ
	ValidToCancellation = 2, // معتبر تا لغو
	ExecuteAndRemove = 3, // انجام و حذف
	TradingSession = 4 // جلسه معاملاتی
}

export enum OrderFormControlIds {
	quantity = 'quantity',
	price = 'price',
	totalDesiredExpense = 'totalDesiredExpense',
	iceberg = 'iceberg'
}

export enum EasyValidityTypeCode {
	Day = 0, // روز
	Week = 5, // هفته
	Month = 6, // ماه
	ValidToDate = 1, // معتبر تا تاریخ
	ValidToCancellation = 2, // معتبر تا لغو
	ExecuteAndRemove = 3 // انجام و حذف
}

export interface IEasyValidityType {
	typeCode: EasyValidityTypeCode;
	typePersianName: string;
}

export class EasyValidityType implements IEasyValidityType {
	private _typeCode: EasyValidityTypeCode;

	constructor(validityTypeCode: number) {
		this._typeCode = validityTypeCode;
	}
	public get typeCode(): EasyValidityTypeCode {
		return this._typeCode;
	}
	public get typePersianName(): string {
		switch (this.typeCode) {
			case EasyValidityTypeCode.Day:
				return 'روز';
			case EasyValidityTypeCode.Week:
				return 'هفته';
			case EasyValidityTypeCode.Month:
				return 'ماه';
			case EasyValidityTypeCode.ValidToDate:
				return 'معتبر تا تاریخ';
			case EasyValidityTypeCode.ExecuteAndRemove:
				return 'انجام و حذف';
			case EasyValidityTypeCode.ValidToCancellation:
				return 'معتبر تا لغو';
			default:
				return 'خطا: اعتبار صحیح نیست';
		}
	}
}
export interface IValidityType {
	code: number;
	name: string;
}
export const ValidityPersianName: { [key in EasyValidityTypeCode]: string } = {
	[EasyValidityTypeCode.Day]: 'روز',
	[EasyValidityTypeCode.Week]: 'هفته',
	[EasyValidityTypeCode.Month]: 'ماه',
	[EasyValidityTypeCode.ValidToDate]: 'معتبر تا تاریخ',
	[EasyValidityTypeCode.ExecuteAndRemove]: 'انجام و حذف',
	[EasyValidityTypeCode.ValidToCancellation]: 'معتبر تا لغو'
};

export enum FinancialProviderCode {
	TBRFinancialDataProvider = 1, // "حساب نزد کارگزار"
	MellatBankFinancialDataProvider = 2, // "بانک ملت"
	SamanFinancialDataProvider = 4, // "بانک سامان"
	SepahFinancialDataProvider = 5, // "بانک سپه"
	KarafarinFinancialDataProvider = 7, // "بانک کارافرین"
	EnovinFinancialDataProvider = 8, // "بانک اقتصاد نوین"
	AnsarFinancialDataProvider = 9, // "بانک انصار"
	PasargadFinancialDataProvider = 10, // "بانک پاسارگاد"
	SarmayehFinancialDataProvider = 11, // "بانک سرمایه"
	ParsianFinancialDataProvider = 12, // "بانک پارسیان"
	TejaratFinancialDataProvider = 13, // "بانک تجارت"
	KhavarMiyanehFinancialDataProvider = 14, // "بانک خاورمیانه"
	RefahFinancialDataProvider = 15, // "بانک رفاه"
	MaskanFinancialDataProvider = 16 // "بانک مسکن"
}

export interface IFinancialProvider {
	financialProviderCode: FinancialProviderCode;
	financialProviderName: string;
	isActive: boolean;
}

export class FinancialProvider implements IFinancialProvider {
	private _financialProviderCode: FinancialProviderCode;

	constructor(financialProviderCode: number) {
		this._financialProviderCode = financialProviderCode;
	}
	public get financialProviderCode(): FinancialProviderCode {
		return this._financialProviderCode;
	}
	public get financialProviderName(): string {
		switch (this.financialProviderCode) {
			case FinancialProviderCode.TBRFinancialDataProvider:
				return 'حساب کارگزار';
			case FinancialProviderCode.MellatBankFinancialDataProvider:
				return 'بانک ملت';
			case FinancialProviderCode.SamanFinancialDataProvider:
				return;
		}
		return '';
	}
	public get isActive(): boolean {
		switch (this.financialProviderCode) {
			case FinancialProviderCode.TBRFinancialDataProvider:
				// case FinancialProviderCode.MellatBankFinancialDataProvider:
				return true;
		}
		return false;
	}
}

export interface IOrderValidationResultModel {
	successful: boolean;
	errorMessage: string;
}

export interface ICreateDraftResponseModel {
	isSuccessfull?: boolean;
	message?: string;
}

export enum OrderActionType {
	make = 'make',
	edit = 'edit',
	copy = 'copy'
}

export enum OrderStructureType {
	draft = 'draft',
	regular = 'regular'
}

export interface CompactOrderActionParams {
	orderId: string;
	actionType: CompactOrderActionType;
	isConfirmed: boolean;
}

export enum CompactOrderActionType {
	Send,
	CopyDraft,
	Edit,
	Delete
}

export enum EntryType {
	Default,
	Other
}

export interface AcceptedManners {
	date: string;
	mannerId: string;
}

export type OrderFormDataType = {
	priceTickSize: number;
	minValidBuyVolume: number;
	minValidSellVolume: number;
	maxValidBuyVolume: number;
	maxValidSellVolume: number;
	maxDailyPrice: number;
	minDailyPrice: number;
	askPrice: number;
	bidPrice: number;
	feeOfPreviousDaysClosingPrice?: number;
};

export interface IOrderFormGroup {
	quantity: FormControl<number>;
	price: FormControl<number>;
	validityType: FormControl<EasyValidityTypeCode>;
	totalDesiredExpense: FormControl<number>;
	financialProviderCode: FormControl<FinancialProviderCode>;
}
export interface IOrderForm {
	quantity: number;
	price: number;
	validityType: EasyValidityTypeCode;
	financialProviderCode: FinancialProviderCode;
}

export interface IOrderFormAlgoGroup {
	quantity: FormControl<number>;
	price: FormControl<number>;
}
